import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "../theme";

export function ThemeButton() {
  const { resolved, setTheme } = useTheme();
  const next = resolved === "dark" ? "light" : "dark";
  return (
    <button className="icon-button" type="button" onClick={() => setTheme(next)} aria-label={`切换为${next === "dark" ? "深色" : "浅色"}模式`}>
      {resolved === "dark" ? <Sun size={20} weight="bold" /> : <Moon size={20} weight="bold" />}
    </button>
  );
}

